import { CorvalBusinessFunction, CorvalMilestone, CorvalQueryBusinessFunctionsArgs, CorvalQueryMilestonesArgs } from '@src/types';
import { queriesLoading }                                                                                       from '@src/store/_apolloUtil';
import { QueryTuple, useLazyQuery, useQuery }                                                                   from '@apollo/react-hooks';
import { DecisionEngineQueries }                                                                                from '@src/queries';
import { OperationVariables }                                                                                   from '@apollo/react-common';


type UseSystemDataHookMethod = () => UseSystemDataHook;

export type UseSystemDataHook = {
    dataLoading: boolean,
    businessFunctionsQuery: QueryTuple<{ businessFunctions: CorvalBusinessFunction[] }, CorvalQueryBusinessFunctionsArgs>
    milestoneQuery: QueryTuple<{ milestones: CorvalMilestone[] }, CorvalQueryMilestonesArgs>
    businessFunctions: CorvalBusinessFunction[],
    milestones: CorvalMilestone[],
};

const businessFunctionQueryFragment = DecisionEngineQueries.queries.GET_BUSINESS_FUNCTIONS();
const businessFunctionQueryOptions: OperationVariables = {
    variables:   { order: { name: 'ASC' } },
    fetchPolicy: 'cache-and-network'
};

const milestoneQueryFragment = DecisionEngineQueries.queries.GET_MILESTONES();
const milestoneQueryOptions: OperationVariables = {
    variables:   { order: { name: 'ASC' } },
    fetchPolicy: 'cache-and-network'
};

export const useSystemData: UseSystemDataHookMethod = () => {

    const businessFunctionsReq = useQuery<{ businessFunctions: CorvalBusinessFunction[] }>( businessFunctionQueryFragment, businessFunctionQueryOptions ),
          milestonesReq        = useQuery<{ milestones: CorvalMilestone[] }>( milestoneQueryFragment, milestoneQueryOptions );

    const getBusinessFunctions = useLazyQuery( businessFunctionQueryFragment, businessFunctionQueryOptions ),
          getMilestones        = useLazyQuery( milestoneQueryFragment, milestoneQueryOptions );

    const isLoading = queriesLoading( [
        businessFunctionsReq
    ] );

    return {
        dataLoading: isLoading,

        businessFunctions: businessFunctionsReq.data?.businessFunctions ?? [],
        milestones:        milestonesReq.data?.milestones ?? [],

        businessFunctionsQuery: getBusinessFunctions,
        milestoneQuery:         getMilestones,
    };
};
